export default "__VITE_ASSET__D5EhiHpc__"